







import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/layout/Header.vue';
import Body from '@/components/layout/Body.vue';

@Component({
  components: { Header, Body },
})
export default class App extends Vue {}
